import React, { useState, useEffect, useRef } from 'react';
import DOMPurify from 'dompurify';
import QuestionCarousel from '../Components/QuestionCarousel';
import { addTooltipsToText } from "../tooltipUtils.jsx";
import VocabularyMatch from "../vocabmatchcolumn.jsx";
import vocabData from "../../Components/VocabularyListComps/Data/vocabcolumn.json";
import { FaAngleDown } from 'react-icons/fa';
import SEO, { SITE_NAME } from '../../Components/SEO';
import './ReadingActivity.css';

const ReadingActivity = ({ data, skipSEO }) => {
  const [answers, setAnswers] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [isGridVisible, setIsGridVisible] = useState(true);
  const [showVocab, setShowVocab] = useState(false);
  const topicMenuRef = useRef(null);

  useEffect(() => {
    if (data?.paragraphs?.[0]?.questions?.length) {
      const qCount = data.paragraphs[0].questions.length;
      setAnswers(Array(qCount).fill(''));
    }
  }, [data]);

  const handleAnswerChange = (questionIndex, choice) => {
    const updated = [...answers];
    updated[questionIndex] = choice;
    setAnswers(updated);
    setShowResults(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowResults(true);
  };

  const toggleGridVisibility = () => setIsGridVisible((prev) => !prev);
  const toggleVocab = () => setShowVocab((prev) => !prev);
  const closeVocab = () => setShowVocab(false);

  const readingQuestions = data?.paragraphs?.[0]?.questions || [];

  if (!data) {
    return <div>Loading reading...</div>;
  }

  return (
      <div className="readingActivity-container">
        {!skipSEO && (
        <SEO
          title={`English Reading Exercise: ${data?.readingcompTitle || data?.title || 'Reading Practice'}`}
          description="Free English reading exercise with multiple-choice comprehension questions and vocabulary support."
          name={SITE_NAME}
          type="article"
        />
      )}
        <div className="readingActivityform">
             <div className="reading-image">
                    <img src={data.image} alt="title" />
                </div>
          <div className="readingActivity-text">
            <h3 className="readingTitle">{data.readingcompTitle}</h3>
            {data.paragraphs?.map((p, idx) => (
              <div
                key={idx}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(addTooltipsToText(p.text, data.vocabulary)),
                }}
              />
            ))}
          </div>

          {/* Questions Carousel - using shared component */}
          {readingQuestions.length > 0 && (
            <QuestionCarousel
              questions={readingQuestions}
              answers={answers}
              onAnswerChange={handleAnswerChange}
              onSubmit={handleSubmit}
              showResults={showResults}
              customIcons={true}
              submitLabel="Check Answer"
            />
          )}

          {showVocab && (
            <div className="overlay" onClick={closeVocab}>
              <div className="transcript-overlay" onClick={(e) => e.stopPropagation()}>
                <div className="vocabulary-text">
                  {data.vocabulary?.length ? (
                    <ul>
                      {data.vocabulary.map((item, idx) => (
                        <li key={idx} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }} />
                      ))}
                    </ul>
                  ) : (
                    <p>No vocabulary available for this reading.</p>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="readingActivity-vocab-header-box" onClick={toggleGridVisibility}>
            Vocabulary <FaAngleDown />
          </div>
          {isGridVisible && (
            <div className="readingActivity-display-grid">
                  {data.vocabulary?.length ? (
                    <ul>
                      {data.vocabulary.map((item, idx) => (
                        <li key={idx} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }} />
                      ))}
                    </ul>
                  ) : (
                    <p>No vocabulary available for this reading.</p>
                  )}
            </div>
          )}


        </div>
      </div>
     
  );
};

export default ReadingActivity;